import { FC, ReactNode } from 'react'

import styles from './Wrapper.module.scss'

type Props = {
  children?: ReactNode
}

const SectionWrapper: FC<Props> = ({ children }) => <div className={styles.wrapper}>{children}</div>

export default SectionWrapper
